import { AutoSuggestValue } from '../providers/AutoSuggestValue';
import { NotNullValueLabel, NotNullValue, NullValueLabel, NullValue } from '../providers/Constants';

export { default as SingleTextFilterEdit } from './SingleTextFilterEdit';
export { default as BooleanFilterEdit } from './BooleanFilterEdit';

export { default as SingleNumberFilterEdit } from './SingleNumberFilterEdit';
export { default as SingleDecimalFilterEdit } from './SingleDecimalFilterEdit';
export { default as SingleIntegerFilterEdit } from './SingleIntegerFilterEdit';

export { default as RangedNumberFilterEdit } from './RangedNumberFilterEdit';
export { default as RangedDecimalFilterEdit } from './RangedDecimalFilterEdit';
export { default as RangedIntegerFilterEdit } from './RangedIntegerFilterEdit';

export { default as FiltersListButtonGroup } from './FiltersListButtonGroup';
export { default as FiltersListValueButton } from './FiltersListValueButton';
export { default as FiltersListCloseButton } from './FiltersListCloseButton';
export { default as FiltersListAddButton } from './FiltersListAddButton';

export interface FilterButtonProps {
	ariaLabel?: string;
	onClick: () => void;
}

export const AnyValueAutoSuggestValue: AutoSuggestValue = {
	label: NotNullValueLabel,
	value: NotNullValue,
};

export const NoValueAutoSuggestValue: AutoSuggestValue = {
	label: NullValueLabel,
	value: NullValue,
};
